export default __webpack_public_path__ + "static/char-v-04-60e3c7f88a6d223b772e43e16e134097.webp";